export const FETCH_USERS_REQUEST = 'USERS/FETCH_REQUEST';
export const FETCH_USERS_SUCCESS = 'USERS/FETCH_SUCCESS';
export const FETCH_USERS_FAILURE = 'USERS/FETCH_FAILURE';

export const PATCH_USER = 'USER/PATCH/REQUEST';
export const PATCH_USER_SUCCESS = 'USER/PATCH/SUCCESS';
export const PATCH_USER_FAILURE = 'USER/PATCH/FAILURE';

export const DOWNLOAD_USER_SHEET_REQUEST = 'USERS_SHEET/DOWNLOAD/REQUEST';

export const CHECK_USER_REQUEST = 'CHECK_USER_REQUEST';
export const CHECK_USER_SUCCESS = 'CHECK_USER_SUCCESS';
export const CHECK_USER_FAILURE = 'CHECK_USER_FAILURE';

export const CHECK_AND_UPDATE = 'USER/CHECK_AND_UPDATE';

export const CHECKS_MODAL_APPROVE = 'USER/CHECKS_MODAL/APPROVE';
export const CHECKS_MODAL_REJECT = 'USER/CHECKS_MODAL/REJECT';
export const ADD_USER_WARNING = 'USER/CHECKS_MODAL/ADD_WARN';

export const SHOW_PASSWORD_MODAL = 'USER/PASSWORD_MODAL/SHOW';
export const HIDE_PASSWORD_MODAL = 'USER/PASSWORD_MODAL/HIDE';

/** Impersonate modal filters */
export const SET_IMPERSONATE_MODAL_FILTER = 'IMPERSONATE/MODAL/FILTER/SET';
export const SET_IMPERSONATE_MODAL_FILTERS = 'IMPERSONATE/MODAL/FILTERS/SET';
export const CLEAR_IMPERSONATE_MODAL_FILTER = 'IMPERSONATE/MODAL/FILTERS/CLEAR';
export const REMOVE_IMPERSONATE_MODAL_FILTER = 'IMPERSONATE/MODAL/FILTERS/REMOVE';

export const OPEN_IMPERSONATE_MODAL = 'IMPERSONATE/MODAL/OPEN';
export const CLOSE_IMPERSONATE_MODAL = 'IMPERSONATE/MODAL/CLOSE';

/** Current User */
export const CURRENT_USER_DATA_REQUEST = 'CURRENT_USER_DATA_REQUEST';
export const CURRENT_USER_DATA_SUCCESS = 'CURRENT_USER_DATA_SUCCESS';
export const CURRENT_USER_DATA_FAILURE = 'CURRENT_USER_DATA_FAILURE';

/** Dashboard Customization */
export const PATCH_DASHBOARD_SETTINGS_REQUEST = 'USERS/DASHBOARD/PATCH_REQUEST';
export const PATCH_DASHBOARD_SETTINGS_SUCCESS = 'USERS/DASHBOARD/PATCH_SUCCESS';
export const PATCH_DASHBOARD_SETTINGS_FAILURE = 'USERS/DASHBOARD/PATCH_FAILURE';
export const OPTIMISTIC_UPDATE_DASHBOARD_FIELD = 'USERS/DASHBOARD/OPTIMISTIC_UPDATE_FIELD';
export const ROLLBACK_DASHBOARD_FIELDS = 'USERS/DASHBOARD/ROLLBACK_FIELDS';
